import React from 'react'

function Home () {
  return (
    <section className="hero is-fullheight-with-navbar is-dark">
      <div className="hero-body background has-text-centered">
        <div className="container">
          <h1 className="title has-text-centered">
            Final Space <span>🚀🍪</span>
          </h1>
        </div>
      </div>
    </section>
  )
}

export default Home